<template>
  <div class="small-print">
    <div class="small-print__content">
      <div class="small-print__title">Small Print You’re Going to Want to Read:</div>
      <div class="small-print__text">
        <p>
          Discounts cannot be applied to previous orders or be combined with any other offer. We
          reserve the right to change or discontinue this offer at any time.
        </p>
        <ul>
          <li class="small-print__left-list-item" v-for="(print, index) in leftItems" :key="index">
            <span class="small-print__text" v-html="print.content"></span>
          </li>
        </ul>
      </div>
    </div>
    <div class="small-print__content">
      <div class="small-print__main-text">
        INE Premium Plus will auto-renew annually at the published rate (USD) after the initial
        purchase cost unless canceled prior to the subscriber's renewal date. This renewal will
        include all Premium content, one Skill Dive focus area, and one free certification annually.
      </div>
      <ul>
        <li class="small-print__right-list-item" v-for="(print, index) in rightItems" :key="index">
          <span class="small-print__text" v-html="print.content"></span>
        </li>
      </ul>
      <div class="small-print__text">
        If you have any questions, please email us at&nbsp;
        <a class="small-print__link" href="mailto:support@ine.com">support@ine.com</a>.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PremiumPlusPrint',

  data: () => ({
    rightItems: [
      {
        content:
          'Premium Plus includes a free INE Security exam voucher. The INE Security Certification exam voucher code will be delivered via email within 24 hours of completing your purchase. You will have two attempts to pass the certification exam. This offer excludes ICCA.',
      },
      {
        content:
          'Premium Plus includes one (1) Skill Dive focus area. Additional Skill Dive focus areas may be purchased for $99. Skill Dive offers 240 lab hours annually. Lab hours DO NOT roll over annually. Additional lab hours can be purchased.',
      },
    ],
    leftItems: [
      { content: '$200 off Premium Plus Subscription' },
      { content: 'This option is for new subscribers only.' },
      { content: 'Use coupon code 200PREMPLUS25 at checkout.' },
    ],
  }),
}
</script>

<style lang="scss" scoped>
.small-print {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
  margin-bottom: 60px;

  @include tablet {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 60px;
    align-self: stretch;
  }
  ul {
    margin: 0;
    padding-left: 15px;
    line-height: 12px;
    li {
      line-height: 12px;
      &::marker {
        color: var(--dusty-gray);
      }
    }
    ul {
      margin-top: 10px;
      list-style-type: inherit;
    }
  }
  &__right-list-item {
    margin-bottom: 10px;
  }
  &__left-list-item {
    margin-bottom: 0;
  }
  &__content {
    flex: 1 0 0;
  }
  &__content:first-child {
    @include tablet {
      max-width: 296px;
    }
  }
  &__title {
    color: var(--dusty-gray);
    font-size: rem(12px);
    font-style: normal;
    font-weight: 700;
    line-height: rem(16px);
  }
  &__main-text {
    margin-bottom: 10px;
    color: var(--dusty-gray);
    font-size: rem(12px);
    font-style: normal;
    font-weight: 450;
    line-height: rem(16px);
  }
  &__text {
    color: var(--dusty-gray);
    font-size: rem(12px);
    font-style: normal;
    font-weight: 450;
    line-height: rem(16px);
  }
  &__link {
    color: var(--light-purple);
    font-size: rem(12px);
    font-style: normal;
    font-weight: 450;
    line-height: rem(16px);
  }
}
</style>
